import ATGBasketService from '../implementations/ATGBasketService';
import MockBasketService from '../implementations/MockBasketService';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import BasketService from '../BasketService';

export enum BasketServiceType {
  ATG = 'ATG',
  MOCK = 'MOCK',
}

export default class BasketServiceFactory {
  static createBasketService(type: BasketServiceType = BasketServiceType.ATG): BasketService {
    let service: BasketServiceInterface;

    switch (type) {
      case BasketServiceType.MOCK:
        service = new MockBasketService();
        break;
      default:
        service = new ATGBasketService();
    }

    return new BasketService(service);
  }
}
